import { EventBus } from 'OK/EventBus';

const PREFIX = 'layout.events';

const factory = EventBus.factory(PREFIX);

export interface UpdateCounterPayload {
    id: string;
    newValue: number;
}

export const UPDATE_COUNTER = factory<UpdateCounterPayload>('updateCounter');

export interface UpdateMenuSwitchPayload {
    id: string;
    newValue: boolean;
}

export const UPDATE_MENU_SWITCH = factory<UpdateMenuSwitchPayload>('updateMenuSwitch');

export const OPEN_NAVIGATION_MENU = factory('openNavigationMenu');
export const CLOSE_NAVIGATION_MENU = factory('closeNavigationMenu');
